module.exports = __webpack_public_path__ + "static/img/Placeholder-pana.dd4df86.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/Placeholder-pana.svg
// module id = 3xVC
// module chunks = 1